import React, { useState, useContext, useEffect } from 'react'
import styled from 'styled-components'
import {
  FlexView,
  Table as StandardTable,
  Button,
  Spinner,
} from '../components/common'
import { useTranslation } from 'react-i18next'
import { AppContext } from '../stores/AppStore'
import { UserContext } from 'stores/UserStore'
import { SmartContext } from 'stores/SmartStore'
import { DatePicker, Select } from 'components/form'

const FlexViewHome = styled(FlexView)`
  overflow: hidden;
  background: #000;
  min-width: 100%;
  min-height: 100vh;
  align-items: center;
  justify-content: flex-start;
  background-color: #e5e5e5;
`
const SelectInput = styled(Select)`
  margin-left: 20px;
  min-height: 80px;
`

const Main = styled.div`
  width: 1080px;
`

const TableHeader = styled.div`
  margin: 32px 0px 8px 0px;
  padding: 4px 0px 4px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const TitleCard = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  color: #303030;

  h3 {
    margin: 0px 0px 0px 4px;
  }
`
const Table = styled(StandardTable)`
  background: #fff;
`
const selectName =[
  {
  value: '',
  label: 'All'
  },
  {
    value: 'Paulo',
    label: 'Paulo'
  },
  {
  value: 'Matheus',
  label: 'Matheus'
  },
  {
    value: 'Nayara',
    label: 'Nayara'
  },
  {
    value: 'Tércio',
    label: 'Tércio'
  },
  {
    value: 'Lucas',
    label: 'Lucas'
  },

]
const selectCompany=[
  {
  value: '',
  label: 'All'
  },
  {
  value: 'Petrobras',
  label: 'Petrobras'
  }
]

const CustomerSuccess = () => {
  const DatePickerFrom = (props) => {
    return <DatePicker value={fromDate} onChange={setFromDate} {...props} />
  }

  const DatePickerTo = (props) => {
    return <DatePicker value={toDate} onChange={setTODate} {...props} />
  }

  const DEFAULT_URL = 'collaborative-design/home'

  const { t } = useTranslation()

  const { setPageSubtitle } = useContext(AppContext)
  const { registryLog } = useContext(UserContext)
  const { tableData, getCustomerData, searchData, isLoading } = useContext(
    SmartContext
  )
  const [fromDate, setFromDate] = useState()
  const [toDate, setTODate] = useState()

  const columns = [
    {
      Header: t('customer.table.name'),
      accessor: 'name',
      id: 'name',
    },
    {
      Header: t('customer.table.user'),
      accessor: 'user',
      id: 'user',
    },
    {
      Header: t('customer.table.company'),
      accessor: 'company',
      id: 'company',
    },
    {
      Header: t('customer.table.city'),
      accessor: 'city',
      id: 'city',
    },
    {
      Header: t('customer.table.application'),
      accessor: 'application',
      id: 'application',
    },
    {
      Header: t('customer.table.functionality'),
      accessor: 'functionality',
      id: 'functionality',
    },
    {
      Header: t('customer.table.screen'),
      accessor: 'screen',
      id: 'screen',
    },
    {
      Header: t('customer.table.mask-action'),
      accessor: 'mask-action',
      id: 'mask-action',
    },
    {
      Header: t('customer.table.action'),
      accessor: 'action',
      id: 'action',
    },
    {
      Header: t('customer.table.date'),
      accessor: (row) =>
        new Date(row.date).toLocaleDateString('pt-br', { timeZone: 'utc' }),
      id: 'date',
    },
    {
      Header: t('customer.table.last-access'),
      accessor: (row) =>
        new Date(row.date).toLocaleDateString('pt-br', { timeZone: 'utc' }),
      id: 'last-access',
    },
  ]

  const onSearchClick = () => {
    searchData({ fromDate, toDate })
  }

  useEffect(() => {
    setPageSubtitle(t('customer.pageTitle'))
    registryLog('client_in', DEFAULT_URL)
    getCustomerData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <FlexViewHome>
      {!isLoading ? (
        <Main>
          <TableHeader>
            <DatePickerFrom label={t('report.from')} name="from" /> &nbsp;&nbsp;
            <DatePickerTo label={t('report.to')} width="100%" name="to" />{' '}
            <SelectInput 
              label={t('customer.table.name')} 
              width="100%" 
              options={selectName}
              placeholder={t('customer.all')}/>
              
            <SelectInput 
              label={t('customer.table.company')} 
              width="100%" 
              options={selectCompany}
              placeholder={t('customer.all')}/>
            &nbsp;&nbsp;
            <TitleCard>
              <Button
                style={{ marginTop: '20px' }}
                backgroundColor="primary"
                color="white"
                fontSize="small"
                elevation="medium"
                onClick={onSearchClick}
              >
                {' '}
                &nbsp;
                {t('report.search')}
              </Button>{' '}
              &nbsp; &nbsp;
            </TitleCard>
          </TableHeader>
          <Table
            width="100%"
            columns={columns}
            data={tableData}
            sortable
            elevation="none"
            borderRadius="card"
            paginated
            margin="8px 16px"
            style={{ whiteSpace: 'nowrap' }}
          />
        </Main>
      ) : (
        <FlexView
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="100%"
        >
          <Spinner />
        </FlexView>
      )}
    </FlexViewHome>
  )
}
export default CustomerSuccess
